import React, { Component, createRef } from 'react';
import {
    Input, Icon, Popover, Select, Modal, Button,
} from 'antd';
import { connect } from 'react-redux';
import { searchLeadCountyRequest } from '../redux/actions/search_lead_county.actions';
import { debounce } from '../../../../shared/helpers';
import { createNewCountyRequest } from '../redux/actions/create_new_county.actions';
import { preferred_contact_method_options, preferred_contact_time_options } from '../statics';

const { Option } = Select;

const hintContent = {
    name: 'In the text box, please enter the name of customer',
    email: 'In the text box, please enter the email of customer',
    phone: 'In the text box, please enter the phone of customer',
    country: 'Using the list below, please select what county the motorbike resides in',
    preferred_contact_method: 'Using the options, please select preferred contact method for customer',
    preferred_contact_time: 'Using the options, please select preferred contact time for customer',
};

const formFieldStyle = {
    fieldStyle: { width: 428 },
    container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
    wrapper: { width: '100%' },
    hintContainer: { display: 'flex', alignItems: 'center', marginTop: 7 },
    hintIconStyle: { marginLeft: 10, fontSize: 18 },
    errorIconStyle: { margin: '0 5px' },
};


class CustomerInfo extends Component {
    formRef = createRef();

    constructor(props) {
        super(props);
        this.state = {
            searched: false,
            create_county: null,
            loading: false,
        };
    }

    componentDidMount() {
        this.formRef.current.on('keyup', '[db_key]', (event) => {
            const db_key = event.target.getAttribute('db_key');
            const { value } = event.target;

            this.props.Lead_create_data.ref_lead_customer.set({ [db_key]: value });
            this.forceUpdate();
        });

        this.props.searchLeadCountyRequest('');
    }

    requestData = (value, callback) => callback(value);

    runFetch = debounce(this.requestData, 500);

    handleChange = (value, field) => {
        this.props.Lead_create_data.set({ [`ref_lead_customer.${field}`]: value });
        this.forceUpdate();
    };

    handleChangeCounty = (value) => {
        this.props.Lead_create_data.set({ 'ref_lead_customer.address.county': value });
        this.forceUpdate();
    };

    searchCounty = (value) => {
        this.setState({ searched: true, create_county: value });
        this.runFetch(value, this.props.searchLeadCountyRequest);
    };

    createNewCounty = () => Modal.confirm({
        title: 'Are you sure want to create new county, named:',
        width: 650,
        content: (
            <div>
                <Input
                    style={{ width: 350, marginTop: 5 }}
                    defaultValue={this.state.create_county}
                    onChange={e => this.setState({ create_county: e.target.value })}
                />
            </div>
        ),
        okText: 'Confirm',
        onOk: () => {
            this.setState({ searched: false });
            this.props.createNewCountyRequest({ name: this.state.create_county });
        },
    });


    render() {
        const data = this.props.Lead_create_data;
        const { counties } = this.props;
        data.errors = {};
        data.validateSync();

        return (
            <div style={{ maxWidth: 470, marginBottom: 20 }} ref={this.formRef}>
                <div style={{ marginTop: 5 }}>
                    <h5>Name </h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Input
                                maxLength="60"
                                placeholder="Enter customer name"
                                db_key="full_name"
                                style={formFieldStyle.fieldStyle}
                                defaultValue={data.ref_lead_customer.full_name}
                            />
                            <span
                                style={{
                                    color: 'red',
                                    visibility: data.errors['ref_lead_customer.full_name']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_lead_customer.full_name'] && data.errors['ref_lead_customer.full_name'].message}
                            </span>

                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.name} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 5 }}>
                    <h5>Customer email address (so we can send a valuation)</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Input
                                placeholder="Enter customer email address"
                                db_key="email"
                                style={formFieldStyle.fieldStyle}
                                defaultValue={data.ref_lead_customer.email}
                            />
                            <span
                                style={{
                                    color: 'red',
                                    visibility: data.errors['ref_lead_customer.email']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_lead_customer.email'] && data.errors['ref_lead_customer.email'].message}
                            </span>
                        </div>

                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.email} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 5 }}>
                    <h5>Customer phone number (so we can send a valuation)</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Input
                                type="text"
                                placeholder="Enter customer phone number"
                                db_key="phone"
                                style={formFieldStyle.fieldStyle}
                                defaultValue={data.ref_lead_customer.phone}
                            />
                            <span
                                style={{
                                    color: 'red',
                                    visibility: data.errors['ref_lead_customer.phone']
                                        ? 'visible'
                                        : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['ref_lead_customer.phone'] && data.errors['ref_lead_customer.phone'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.phone} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 5 }}>
                    <h5>County (so we can ensure we can offer our collection service)</h5>
                    <div style={formFieldStyle.container}>
                        <Select
                            db_key_select="county"
                            defaultValue={data.ref_lead_customer.address.county && data.ref_lead_customer.address.county.toJSON()}
                            showSearch
                            allowClear
                            style={formFieldStyle.fieldStyle}
                            placeholder="Select county"
                            optionFilterProp="children"
                            onSearch={this.searchCounty}
                            onChange={this.handleChangeCounty}
                            filterOption={() => true}
                        >
                            {counties.data.map(county => <Option key={county._id} value={county._id}>{county.name}</Option>)}
                        </Select>
                        <Button
                            hidden={!(this.state.searched && counties.data.length === 0)}
                            onClick={this.createNewCounty}
                            style={{ marginLeft: 5 }}
                        >
                            Create County
                        </Button>

                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.country} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>


                <div style={{ marginTop: 5 }}>
                    <h5>Preferred contact method</h5>
                    <div style={formFieldStyle.container}>
                        <Select
                            db_key_select="preferred_contact_method"
                            defaultValue={data.ref_lead_customer && data.ref_lead_customer.preferred_contact_method}
                            allowClear
                            style={formFieldStyle.fieldStyle}
                            placeholder="Select preferred contact method"
                            optionFilterProp="children"
                            onChange={value => this.handleChange(value, 'preferred_contact_method')}
                            filterOption={() => true}
                        >
                            {
                                preferred_contact_method_options.map(
                                    (contact_method, index) => <Option key={index} value={contact_method}>{contact_method}</Option>,
                                )
                            }
                        </Select>

                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.preferred_contact_method} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

                {
                    data.ref_lead_customer
                    && data.ref_lead_customer.preferred_contact_method !== ''
                    && data.ref_lead_customer.preferred_contact_method !== 'Email'
                    && data.ref_lead_customer.preferred_contact_method !== 'SMS'
                    && (
                        <div style={{ marginTop: 5 }}>
                            <h5>Preferred contact time</h5>
                            <div style={formFieldStyle.container}>
                                <Select
                                    db_key_select="preferred_contact_time"
                                    defaultValue={data.ref_lead_customer && data.ref_lead_customer.preferred_contact_time}
                                    allowClear
                                    style={formFieldStyle.fieldStyle}
                                    placeholder="Select preferred contact time"
                                    optionFilterProp="children"
                                    onChange={value => this.handleChange(value, 'preferred_contact_time')}
                                    filterOption={() => true}
                                >
                                    {
                                        preferred_contact_time_options.map(
                                            (contact_time, index) => <Option key={index} value={contact_time}>{contact_time}</Option>,
                                        )
                                    }
                                </Select>

                                <div style={formFieldStyle.hintContainer}>
                                    <Popover content={hintContent.preferred_contact_time} trigger="click">
                                        <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    )
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { counties, loading, create_new_county } = state.Leads.Lead_create;
    return { counties, loading, create_new_county };
};

export default connect(mapStateToProps, { searchLeadCountyRequest, createNewCountyRequest })(CustomerInfo);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/components/CustomerInfo.js